'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'film-canister';
var width = 576;
var height = 512;
var aliases = ["film-cannister"];
var unicode = 'f8b7';
var svgPathData = 'M104 40l0 8 144 0 0-8c0-13.3-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24zM88 48l0-8c0-22.1 17.9-40 40-40l96 0c22.1 0 40 17.9 40 40l0 8 48 0 32 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-24 0 0 432 24 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-32 0L40 512 8 512c-4.4 0-8-3.6-8-8s3.6-8 8-8l24 0L32 64 8 64c-4.4 0-8-3.6-8-8s3.6-8 8-8l32 0 48 0zm0 16L48 64l0 432 256 0 0-432-40 0-16 0L104 64 88 64zM408 176c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24l16 0zm-24 24l0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8zm8 136l16 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24zm0 16c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0zM504 176c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24l16 0zm-24 24l0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8zm56-56l-184 0 0-16 184 0c22.1 0 40 17.9 40 40l0 136c0 22.1-17.9 40-40 40c-13.3 0-24 10.7-24 24l0 40c0 22.1-17.9 40-40 40l-120 0 0-16 120 0c13.3 0 24-10.7 24-24l0-40c0-22.1 17.9-40 40-40c13.3 0 24-10.7 24-24l0-136c0-13.3-10.7-24-24-24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFilmCanister = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;